'use strict';

module.exports = {
  abs: Math.abs,
  pow: Math.pow,
  min: Math.min,
  max: Math.max,
  ceil: Math.ceil,
  floor: Math.floor,
  round: Math.round
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/mathAliases.js
// module id = 13
// module chunks = 0